import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberWithSpaces'
})
export class NumberWithSpacesPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (args === 'roundingFalse') {
      if (value > 0) {
        let val = value.toString();
        if (val.indexOf(".") !== -1) {
          val = val.slice(0, (val.indexOf(".")))
        }
        return val;
      }
      if (value === 0) {
        return 0;
      }
      return '-';
    } else if(args === 'toFixed'){
      if (value === 0) {
        return '-';
      }
      if (typeof value === 'string' && value === '0') {
        return null;
      }
      if (value !== null) {
        if (value.toString().indexOf(".") > -1) {
          let val = value.toString().substring(0, value.toString().indexOf(".") + 3);
          return val.replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ",");
        } else if (value.toString().indexOf(",") > -1) {
          let val = value.toString().substring(0, value.toString().indexOf(",") + 3);
          return val.replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ",");
        } else {
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }
      }
    } else {
      if (value === 0) {
        return '-';
      }
      if (typeof value === 'string' && value === '0') {
        return null;
      }
      if (value !== null) {
        // if (value.toString().indexOf(".") > -1) {
        //   let val = parseFloat(value.toString()).toFixed(1);
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ",");
      }
    }
    return '-';
  }

}
